import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../common/components/table";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectOrdersListItems, selectOrdersPrintItem } from "../../../../../redux/orders/selector";
import { orders } from "../../../../../redux/orders/action";
import PageLoader from "../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../redux/library/selector";
import storePersist from "../../../../../redux/storePersist";

const DBAOrders = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const prindPdfData = useSelector(selectOrdersPrintItem)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectOrdersListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'OrderNumber', headerName: 'Order Number', isEdit: true, searchField: 'OrderNumber', sortable: true, filter: true, filterType: 'text'
        // isGeneratedPDF: true 
      },
      // { field: 'OpenNetworkOrder.InvoiceNumber', headerName: 'ON Invoice Number', sortable: true, filter: false, isGeneratedPDF: true },
      // { field: 'MarketPlaceOrder[0].InvoiceNumber', headerName: 'MO Invoice Number' },
      { field: 'InvoiceNumber', headerName: 'Invoice Number', isGeneratedPrintOrders: true },
      { field: 'OrderPId', headerName: 'OrderPId', searchField: 'OrderPId', sortable: true, filter: true, filterType: 'text' },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'ConsumerDBAName', headerName: 'Consumer DBAName', searchField: 'ConsumerDBAName', sortable: true, filter: true, filterType: 'text' },

      { field: 'ProviderAccountName', headerName: 'Provider Account Name', searchField: 'ProviderAccountName', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'OrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.OrderStatus },
        sortable: true,
        filter: false,
        isOrderEditable: true
      },
      {
        field: 'FullfillmentStatusId',
        headerName: 'Fullfillment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.FullfillmentStatus },
        sortable: true,
        filter: false
      },
      {
        field: 'ShippingStatusId',
        headerName: 'Shipping Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus },
        sortable: true,
        filter: false,
        isShipmentEditable: true
      },
      {
        field: 'PaymentMethodId',
        headerName: 'Payment Method',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.PaymentMethod },
        isRowColorDecider: true,
        sortable: true,
        filter: false
      },
      {
        field: 'PaymentStatusId',
        headerName: 'Payment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.PaymentStatus },
        isRowColorDecider: true,
        sortable: true,
        filter: false,
        isPaymentEditble: true
      },
      { field: 'OrderSubtotalExclTax', headerName: 'Subtotal ExclTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderTax', headerName: 'OrderTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderSubtotalInclTax', headerName: 'Subtotal InclTax', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'OrderTotal', headerName: 'Total', isCurrencyValueFormat: true, sortable: true, filter: true },
      { field: 'IsSalesOrder', headerName: 'Sales Order', cellRenderer: 'yesNoRenderer' },
      { field: 'IsOpenNetworkOrder', headerName: 'OpenNetwork', cellRenderer: 'yesNoRenderer' },
      { field: 'StoreSalesChannelName', headerName: 'Channel Name' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  useEffect(() => {
    const data = prindPdfData?.result?.items;
    if (data) {
      const windowGlobal: any = typeof window !== 'undefined' && window
      if (windowGlobal) {
        const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
        const companyName = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.CompanyName;
        window.open(
          `${window.location.origin.replace(companyName, `${companyName}.service`)}/print/pos/receipt?type=RECEIPT&openNetworkOrderId=${data?.OrderId}`,
          '_blank',
          windowProps
        );
      }
    }
  }, [prindPdfData]);

  const launchPdfInBrowser = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      const companyName = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.CompanyName;
      window.open(
        // `https://agri.service.digiit.io/print/pos/receipt?type=RECEIPT&openNetworkOrderId=${data.Id}`,
        `${window.location.origin.replace(companyName, `${companyName}.service`)}/print/pos/receipt?type=RECEIPT&openNetworkOrderId=${data?.Id}`,
        '_blank',
        windowProps
      );
    }
  }

  const handleGeneratePdfInvoice = async (data: any) => {
    // await dispatch(orders.print({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/print`,entity:'orders',jsonData:{
    //   Records: [{
    //     OpenNetworkOrderId: data?.OpenNetworkOrder?.Id
    //   }]
    // }}))		  
    launchPdfInBrowser(data);
  }

  const launchPrintInvoiceInBrowser = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      const companyName = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.CompanyName;
      window.open(
        // `https://dbs.scp.digiit.io/print/pos/receipt/?type=RECEIPT&invoiceId=${data.InvoiceId}`,
        `${window.location.origin.replace(companyName, `${companyName}.scp`)}/print/pos/receipt?type=RECEIPT&invoiceId=${data?.InvoiceId}`,
        '_blank',
        windowProps
      );
    }
  }

  const handleGeneratePrintOrdersInvoice = async (data: any) => {
    launchPrintInvoiceInBrowser(data);
  }

  const fetchOrdersList = () => {
    dispatch(orders.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/list`,
      entity: 'orders',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchOrdersList()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(orders.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/delete`,
      entity: 'orders',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Id
            }
          }
        ]
      }
    })).then(() => {
      fetchOrdersList();
    });
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleReloadData = () => {
    fetchOrdersList();
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/list`,
      entity: 'orders',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleOrderStatusClick = async (event: any, dataId: any, reasonId: any) => {
    if (event === -10) {
      await dispatch(orders.resetAction({ actionType: 'update' }))
      await dispatch(orders.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
        entity: 'orders',
        jsonData: {
          Context: {},
          Records: [
            {
              Id: dataId?.Id,
              OrderStatusId: event,
              Code: reasonId
            }
          ]
        }
      })).then(() => {
        fetchOrdersList();
      });
    } else {
      await dispatch(orders.resetAction({ actionType: 'update' }))
      await dispatch(orders.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
        entity: 'orders',
        jsonData: {
          Context: {},
          Records: [
            {
              Id: dataId?.Id,
              OrderStatusId: event
            }
          ]
        }
      })).then(() => {
        fetchOrdersList();
      });
    }
  };

  const handleShippingStatusClick = async (event: any, dataId: any) => {
    await dispatch(orders.resetAction({ actionType: 'update' }))
    await dispatch(orders.update({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
      entity: 'orders',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: dataId?.Id,
            ShippingStatusId: event
          }
        ]
      }
    })).then(() => {
      fetchOrdersList();
    });
  };

  const handlePaymentStatusClick = async (selectedValue: any, data: any) => {
    await dispatch(orders.resetAction({ actionType: 'update' }))
    await dispatch(orders.update({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
      entity: 'orders',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.Id,
            PaymentStatusId: selectedValue?.PaymentStatusId,
            PaidAmount: selectedValue?.PaidAmount
          }
        ]
      }
    })).then(() => {
      fetchOrdersList();
    });
  };

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items[0]?.Message}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          enableFilter={true} onSearch={handleSearch}
          onOrderStatusClick={handleOrderStatusClick}
          onShippingStatusClick={handleShippingStatusClick}
          onPaymentStatusClick={handlePaymentStatusClick}
          onGeneratePrintOrderInvoice={handleGeneratePrintOrdersInvoice} onGeneratePdfInvoice={handleGeneratePdfInvoice}
          headingName="DBA Orders"
        />
      }
    </>
  );
};

export default DBAOrders;
